import { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postOrgStage, deleteOrgStage, getOrgStage, postOrgStageSave } from '../../apiservices/ApiServices';

const OrganizationStage = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState([]);
    const [deleteData, setDeleteData] = useState([]);
    const [deleteList, setDeleteList] = useState([]);

    const postOrgStages = async (postData) => {
        setLoading(true);
        try {
            const res = await postOrgStage(postData);
            setData(res.data.data.records);
            setLoading(false);
            //postCommonMasters();
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateOrgStage = async () => {
        let postData = {}
        setLoadings(true);
        try {

            const res = await postOrgStage(postData);
            setData(res.data.data.records);
            setLoadings(false);

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {}
        postOrgStages(postData);
    }, []);

    const formattedData = useMemo(() => {
        return data?.map(record => ({
            ...record,
            stageNames: record.stages?.map(stage => stage.stage_name).join(', ') || 'No stages'
        })) || [];
    }, [data]);

    const columns = useMemo(
        () => [
            {
                Header: "Organiztion Type Name",
                accessor: "name",
            },
            {
                Header: "Organiztion Type Stage",
                accessor: "stageNames",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const emptyStatement = {
        stgName: '',
        name: '',
        stages: {
            stageId: '',
            stageName: '',
            stageColor: '',
            displayOrder: '',
            isDefault: 0,
        }
    };

    const mapApiDataToFormikValues = (apiData) => {
        return apiData?.map(item => ({
            stageId: item?.stage_id || '',
            stageName: item?.stage_name || '',
            stageColor: item?.stage_color || '',
            isDefault: item?.is_default || '',
            displayOrder: item?.display_order || '',
        })) || [];
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        stages: [emptyStatement]
    });

    const add = () => {
        setFieldValue('stages', [...values.stages, { ...emptyStatement }]);
    };

    const remove = (index) => {
        const removedItem = values.stages[index];
        if (removedItem?.stageId) {
            setDeleteList((prev) => [...prev, removedItem.stageId]);
        }
        const updated = values.stages.filter((_, i) => i !== index);
        setFieldValue('stages', updated);
    };

    const transformFormValuesToPostData = (values) => {
        return {
            org_type_id: values.name,
            deleted_stage_ids: deleteList || [],
            stages: values.stages.map((item) => ({
                stage_id: item?.stageId,
                stage_name: item?.stageName,
                stage_color: item?.stageColor,
                display_order: item?.displayOrder,
                is_default: item?.isDefault,
            })),
        };
    };

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            const postData = transformFormValuesToPostData(values);
            try {
                const res = await postOrgStageSave(postData);
                toast.success(res.data.message);
                postUpdateOrgStage();
                setLoadings(false);
                setShowModal(false);
                formik.resetForm();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });

    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setShowModal(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        formik.resetForm();
        setDeleteList([]);
        setLoadings(true);
        try {
            const res = await getOrgStage(rowData.id);

            setFieldValue('stgName', res.data.data.name);
            setFieldValue('name', res.data.data.id);

            if (res?.data?.data?.stages?.length) {
                const prefill = mapApiDataToFormikValues(res.data.data?.stages);
                setFieldValue('stages', prefill);
            }

            setLoadings(false);
            setShowModal(true);

        } catch (error) {
            setShowModal(false);
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleDelete = async (rowData) => {
        setDeleteData(rowData);
        setShow(true);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteOrgStage(deleteData?.id);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdateOrgStage();
            setDeleteData([])
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Organization Stage" active="Organiztion Stage" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table notAddnew">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Organiztion Stage</h1>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={formattedData}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={showModal}
                handleClose={() => setShowModal(false)}
                title={`Edit Org. ${values.stgName} Stage`}
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    {values.stages.map((stage, index) => (
                        <div key={index} className="fieldsets mainFS">
                            <div className='fieldsetsboxs'>
                                <h6>stage {index + 1}</h6>
                                <div className="addreovebtns">
                                    <button type="button" className="btn add-btn" onClick={add}>+</button>
                                    {values.stages.length > 1 && (
                                        <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                    )}
                                </div>
                            </div>
                            <div className='formsBox'>
                                <Row>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Stage Name</label>
                                            <input type="text"
                                                name="stageName"
                                                className="form-control"
                                                autoComplete='off'
                                                value={stage.stageName}
                                                onChange={(e) => setFieldValue(`stages[${index}].stageName`, e.target.value)}
                                            />
                                            {errors?.stages?.[index]?.stageName &&
                                                touched?.stages?.[index]?.stageName && (
                                                    <p className="errormsg">{errors.stages[index].stageName}</p>
                                                )}

                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Stage Color</label>
                                            <input type="text"
                                                name="stageColor"
                                                className="form-control"
                                                autoComplete='off'
                                                value={stage.stageColor}
                                                onChange={(e) => setFieldValue(`stages[${index}].stageColor`, e.target.value)}
                                            />
                                            {errors?.stages?.[index]?.stageColor &&
                                                touched?.stages?.[index]?.stageColor && (
                                                    <p className="errormsg">{errors.stages[index].stageColor}</p>
                                                )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">display Order</label>
                                            <input type="text"
                                                name="displayOrder"
                                                className="form-control"
                                                autoComplete='off'
                                                value={stage.displayOrder}
                                                onChange={(e) => setFieldValue(`stages[${index}].displayOrder`, e.target.value)}
                                            />
                                            {errors?.stages?.[index]?.displayOrder &&
                                                touched?.stages?.[index]?.displayOrder && (
                                                    <p className="errormsg">{errors.stages[index].displayOrder}</p>
                                                )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                <label className="form-label">Is Default</label>
                                                <div className="switchs" style={{ marginLeft: 10 }}>
                                                    <input
                                                        type="checkbox"
                                                        name='isDefault'
                                                        className="form-control"
                                                        autoComplete='off'
                                                        checked={stage.isDefault === 1}
                                                        onChange={(e) => {
                                                            const updated = values.stages.map((item, i) => ({
                                                                ...item,
                                                                isDefault: i === index ? 1 : 0
                                                            }));
                                                            setFieldValue("stages", updated);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="slider round"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    ))}

                    <div className='modalfooters'>
                        <div className='button-boxs grid'>

                            <button type='submit' className='btn btn-primary'>Submit</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete {deleteData.name} Stage?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default OrganizationStage